<template>
  <div class="row">
    <div class="article_info_item col-12 col-sm-6">
      <span class="article_tag">場次起始日</span>{{ orientationInfo.orientation_start_date || new Date() | moment('YYYY-MM-DD(ddd) A hh:mm') }}
    </div>
    <div class="article_info_item col-12 col-sm-6">
      <span class="article_tag">場次截止日</span>{{ orientationInfo.orientation_end_date || new Date() | moment('YYYY-MM-DD(ddd) A hh:mm') }}
    </div>
    <div class="article_info_item col-12">
      <span class="article_tag">場次費用/場</span>{{ orientationInfo.orientation_charge }} 元
    </div>
    <div class="article_info_item col-12">
      <span class="article_tag">內容</span>
    </div>
    <div
      class="article_info_item col-12"
      v-html="orientationInfo.orientation_content"
    />
    <slot />
  </div>
</template>
<script>
export default {
  name: 'RecruitmentOrientationIntroduce',
  props: {
    orientationInfo: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
